import Vue from 'vue'
import Component from 'vue-class-component'
import moduleStore from '../../store/videoEditor'
import PageState from '../../store/state'

@Component({})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames
})
export default class TextTemplateContent extends Vue {

  state = new PageState()

  created(moduleData: IinjectDatas) {
		this.state = <PageState>moduleData.state;
  }

  /** 删除文字模板 */
  handleDeleteTemplate() {
    this.state.operatingTextContent.id = null
    this.state.operatingTextList = this.state.operatingTextList.map((item, index) => {
      return index === this.state.operatingTextIndex ? this.state.operatingTextContent : item
    })
  }

  /** 选择文字模板 */
  handleSelectTemplate(item) {
    if (this.state.operatingTextContent.id === item.id) return
    this.state.operatingTextContent.id = item.id
    if (this.state.operatingTextContent.text) {
      this.state.operatingTextContent.text = this.state.operatingTextContent.text.slice(0, item.maxLength)
    }
    // 设置编辑状态
    this.$bus.$emit(this.$EventBusKey.SELECT_TEXT_TEMPLATE, true)
    // 获取文字模板图片宽高
    let image = document.createElement("img") as HTMLImageElement
    image.setAttribute("src", item.templateUrl);
    image.addEventListener("load", () => {
      this.state.operatingTextContent.width = image.naturalWidth / 2
      this.state.operatingTextContent.height = image.naturalHeight / 2
      
      this.state.operatingTextList = this.state.operatingTextList.map((item, index) => {
        return index === this.state.operatingTextIndex ? this.state.operatingTextContent : item
      })
      console.log('getCoverInfo', this.state.operatingTextContent.width, this.state.operatingTextContent.height)
    });
    image.addEventListener("error", (error) => {
      console.error("图片加载失败", error);
    });
  }

}